import { useState, useEffect } from 'react';
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from '@headlessui/react';
import axios from 'axios';


function HighlightedText({ text, query }) {
  if (!query) return text;

  const regex = new RegExp(`(${query})`, "gi");
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <span key={i} className="bg-yellow-200 font-semibold">
            {part}
          </span>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </>
  );
}

function CCAutocompleteSearch(props) {
    /*
    PROPS

        url: the api url to use for searches
        placeHolder: search box placeholder text
     */
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Debounce helper
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const fetchSuggestions = async (search) => {
    if (!search) return setSuggestions([]);
    setLoading(true);
    try {
      const url = `${props.url}?q=${encodeURIComponent(search)}`;

        const response = await axios.get(url);
        const data = response.data;

      setSuggestions(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetch = debounce(fetchSuggestions, 300);

  useEffect(() => {
    debouncedFetch(query);
  }, [query]);

    const handleSelect = (brandInfo) => {
    if (props.onChange) props.onChange(brandInfo); // 🔑 bubble up full object
  };

  return (
    <Combobox as="div" value={query} onChange={handleSelect}>
      <div className="relative w-72">
        <ComboboxInput
          className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-ccColorTeal"
          placeholder={props.placeHolder ? props.placeHolder : "Search..."}
          onChange={(e) => setQuery(e.target.value)}
        />
        {loading && (
          <div className="absolute right-3 top-2 text-gray-500 text-sm">Loading...</div>
        )}

        {suggestions.length > 0 && (
            <ComboboxOptions className="absolute w-full bg-white border rounded mt-1 max-h-60 overflow-auto z-10 shadow-lg">
            {suggestions.map((item) => (
                <ComboboxOption key={item.brandId} value={item} className={({ active, selected }) =>
                `px-3 py-2 cursor-pointer text-ccColorDarkTeal ${active ? 'bg-ccColorLightTeal' : ''} ${selected ? 'font-semibold' : ''}`
                }>
                <HighlightedText text={item.brandName} query={query} />
                </ComboboxOption>
            ))}
            </ComboboxOptions>
        )}

      </div>
    </Combobox>
  );
}

export default CCAutocompleteSearch;
